import {createApp} from 'vue';
import Entry from "@/Entry";

const entry = createApp(Entry);

export default entry;